export default [
  {
    id: 1,
    title: "Google Docs - Android",
    company: "Google",
    description: "Android, Java, Ant, Maven",
    companyImg: "docs.png",
    duration: "3 Years",
    projectDescription: "Product development, enhancements and support for one of the leading document editing apps on Android platform, that allows creating & editing of Microsoft Office documents, spreadsheet and presentation in the Android phone and tablet.",
    responsibilities: ["Implementation of real-time Comments feature (to add, edit, resolve user comments)",
    "Implementation of real-time Track changes feature (to track the user changes)",
    "Improving the stability of the app (Bug fixes)"] 
  },
  {
    id: 2,
    title: "Asset Cloud & Inventory Cloud",
    company: "Wasp Barcode Technologies",
    description: "Android, Gradle, Swagger, JSON, Volley, SQL",
    companyImg: "wasp.png",
    duration: "3 Years",
    projectDescription: "An easier asset tracking to automate an organization's asset management for improved check-in/check-out processes, faster auditing. Allows an organization to assign responsibility of an asset to an employee, a customer, or even a vendor",
    responsibilities: ["User interface design with material guidelines to support various resolution (Mobile)",
    "Swagger client library generation and integration. Consuming Rest API services.",
    "Consuming database from server and maintaining a local database (Sqlite migrated to Room later)",
    "Barcode scanning through bluetooth paired scanner"] 
  },
  {
    id: 3,
    title: "Google Sheets",
    company: "Google",
    description: "Java script, Apps script",
    companyImg: "sheets.png",
    duration: "1 Year",
    projectDescription: "Migration of Microsoft Excel features to Google Sheets. Experimenting Excel functions through Visual basic editor (macros) and documenting the findings as a YAML file for future reference and implementation. Implementation of MS Excel features for Google sheets using Apps script",
    responsibilities: ["Apps script implementation of MS office features.",
    "Code review and integration"] 
  },
  {
    id: 4,
    title: "Internal Project",
    company: "Habib Bank AG Zurich",
    description: "Java, Vaadin, Web",
    duration: "3 Years",
    companyImg: "hbz_logo.png",
    projectDescription: "Migration of Microsoft Excel features to Google Sheets. Experimenting Excel functions through Visual basic editor (macros) and documenting the findings as a YAML file for future reference and implementation. Implementation of MS Excel features for Google sheets using Apps script",
    responsibilities: ["Core feature implementation (Customer Relationship opening, Verification, Process and Account opening)",
    "Effectively handled monthly releases and stabilized the application",
    "Code review and integration"] 
  }
]

